module.exports = __webpack_public_path__ + "media/images/company/company_03_03-d920733e8d549bc0e09ffe9284a1f2f6.jpg";